"use strict";

Shopify.theme.jsFaqBlock = {
  init: function init($section) {
    let $panel = $section.find('.faq__item-panel')
    let $question = $section.find('.faq__item-question')
 	$question.on('click',function(){
        if($(this).siblings('.faq__item-answer').css('display')=='none'){
            $(this).parent().addClass('tab--open')
            $(this).siblings('.faq__item-answer').slideDown()
        }else{
            $(this).siblings('.faq__item-answer').slideUp(()=>{
                $(this).parent().removeClass('tab--open')
            })
        }
    })
  },
  unload: function unload($section) {
    let $question = $section.find('.faq__item-question')
    $question.off('click');
  }
};